import { useEffect, useState } from "react";
import { MenuItemModifierSet } from "../services/menu/models";
import { useStores } from "./index";

const useModifiersSetsSearch = () => {
    const [query, setQuery] = useState(" ");
    const [result, setResult] = useState([]);
    const {modifiersSetsStore}  = useStores()

    useEffect(() => {
        const res = modifiersSetsStore.searchForModifiersSets(query);
        setResult(res);
    }, [query]);
    return [result, setQuery] as [MenuItemModifierSet[], any]
};
export default useModifiersSetsSearch
